import { useState } from 'react';

const useCostSpecificationModal = () => {
  const [selectedCostPlanManager, setCostPlanManager] = useState<{ manager: any; planItem: any } | null>();
  const [showCostSpecModal, setShowCostSpecModal] = useState(false);

  const toggleModal = () => {
    setShowCostSpecModal((shown) => !shown);
  };

  const showParentModal = () => {
    const modalElementRef = document.querySelector('.crt-add-pension-policy-modal');

    if (modalElementRef) {
      modalElementRef.setAttribute('style', 'display: block !important');
    }
  };

  const hideParentModal = () => {
    const modalElementRef = document.querySelector('.crt-add-pension-policy-modal');

    if (modalElementRef) {
      modalElementRef.setAttribute('style', 'display: none !important');
    }
  };

  return {
    toggleModal,
    showCostSpecModal,
    selectedCostPlanManager,
    setCostPlanManager,
    showParentModal,
    hideParentModal,
  };
};

export default useCostSpecificationModal;
